// TODO: Delete remaining wizard consts once home page is migrated to academy-home-ui
export const WIZARD_PAGE_SIZE = 3;